/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Apikey } from './Apikey';
import {
    ApikeyFromJSON,
    ApikeyFromJSONTyped,
    ApikeyToJSON,
    ApikeyToJSONTyped,
} from './Apikey';

/**
 * 
 * @export
 * @interface ApikeyDeleteResponse
 */
export interface ApikeyDeleteResponse {
    /**
     * Whether the deletion was successful.
     * @type {boolean}
     * @memberof ApikeyDeleteResponse
     */
    success: boolean;
    /**
     * The ID of the deleted API key.
     * @type {string}
     * @memberof ApikeyDeleteResponse
     */
    id: string;
    /**
     * The deleted API key object.
     * @type {Apikey}
     * @memberof ApikeyDeleteResponse
     */
    object: Apikey;
}

/**
 * Check if a given object implements the ApikeyDeleteResponse interface.
 */
export function instanceOfApikeyDeleteResponse(value: object): value is ApikeyDeleteResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('object' in value) || value['object'] === undefined) return false;
    return true;
}

export function ApikeyDeleteResponseFromJSON(json: any): ApikeyDeleteResponse {
    return ApikeyDeleteResponseFromJSONTyped(json, false);
}

export function ApikeyDeleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApikeyDeleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'id': json['id'],
        'object': ApikeyFromJSON(json['object']),
    };
}

export function ApikeyDeleteResponseToJSON(json: any): ApikeyDeleteResponse {
    return ApikeyDeleteResponseToJSONTyped(json, false);
}

export function ApikeyDeleteResponseToJSONTyped(value?: ApikeyDeleteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'id': value['id'],
        'object': ApikeyToJSON(value['object']),
    };
}

